import React from 'react';

// Logo Option A: Geometric Cube with K
export const LogoA = ({ size = 48, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    className={className}
  >
    <defs>
      <linearGradient id="gradientA" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3B82F6" />
        <stop offset="100%" stopColor="#8B5CF6" />
      </linearGradient>
    </defs>
    {/* 3D Cube */}
    <polygon points="50,5 95,30 95,70 50,95 5,70 5,30" fill="url(#gradientA)" />
    <polygon points="50,5 95,30 50,55 5,30" fill="#60A5FA" opacity="0.8" />
    <polygon points="50,55 95,30 95,70 50,95" fill="#4F46E5" opacity="0.6" />
    {/* K Letter */}
    <text x="50" y="62" textAnchor="middle" fill="white" fontSize="40" fontWeight="bold" fontFamily="Arial">K</text>
  </svg>
);

// Logo Option B: Circular with Chain Links
export const LogoB = ({ size = 48, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    className={className}
  >
    <defs>
      <linearGradient id="gradientB" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#10B981" />
        <stop offset="50%" stopColor="#3B82F6" />
        <stop offset="100%" stopColor="#8B5CF6" />
      </linearGradient>
    </defs>
    {/* Outer Ring */}
    <circle cx="50" cy="50" r="45" fill="none" stroke="url(#gradientB)" strokeWidth="6" />
    {/* Inner Circle */}
    <circle cx="50" cy="50" r="32" fill="url(#gradientB)" />
    {/* Chain Link Symbols */}
    <circle cx="50" cy="10" r="6" fill="#60A5FA" />
    <circle cx="85" cy="30" r="6" fill="#8B5CF6" />
    <circle cx="85" cy="70" r="6" fill="#A855F7" />
    <circle cx="50" cy="90" r="6" fill="#10B981" />
    <circle cx="15" cy="70" r="6" fill="#34D399" />
    <circle cx="15" cy="30" r="6" fill="#3B82F6" />
    {/* KOJIRU Text */}
    <text x="50" y="56" textAnchor="middle" fill="white" fontSize="18" fontWeight="bold" fontFamily="Arial">KOJIRU</text>
  </svg>
);

// Logo Option C: Abstract K with Flowing Lines
export const LogoC = ({ size = 48, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    className={className}
  >
    <defs>
      <linearGradient id="gradientC1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#EF4444" />
      </linearGradient>
      <linearGradient id="gradientC2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3B82F6" />
        <stop offset="100%" stopColor="#8B5CF6" />
      </linearGradient>
    </defs>
    {/* Background Circle */}
    <circle cx="50" cy="50" r="45" fill="#0A0A0A" />
    {/* Abstract K - Left vertical */}
    <rect x="22" y="20" width="12" height="60" rx="6" fill="url(#gradientC2)" />
    {/* Abstract K - Top diagonal */}
    <rect x="34" y="20" width="12" height="40" rx="6" fill="url(#gradientC1)" transform="rotate(45 40 40)" />
    {/* Abstract K - Bottom diagonal */}
    <rect x="34" y="40" width="12" height="40" rx="6" fill="url(#gradientC2)" transform="rotate(-45 40 60)" />
    {/* Accent dots */}
    <circle cx="75" cy="25" r="8" fill="#3B82F6" opacity="0.8" />
    <circle cx="80" cy="50" r="6" fill="#8B5CF6" opacity="0.6" />
    <circle cx="70" cy="75" r="10" fill="#10B981" opacity="0.7" />
  </svg>
);

// Full Logo with Text
export const KutroLogoFull = ({ variant = 'a', size = 48, showText = true, className = '' }) => {
  const Logo = variant === 'a' ? LogoA : variant === 'b' ? LogoB : LogoC;
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <Logo size={size} />
      {showText && (
        <span className="text-2xl font-bold tracking-tight">
          <span className="bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
            KOJIRU
          </span>
        </span>
      )}
    </div>
  );
};

export default KutroLogoFull;
